import { act } from '@ngrx/effects';
import { createReducer, on } from '@ngrx/store';
// import { OrderInfo,fakeOrderInfo } from 'src/app/models/data/order-info.model';
// import { initialPreference, Preference } from 'src/app/models/data/preference.model';
import { customerVisit, User, UserCredential, UserLocation, Preference, UserAuth, OmisUser, TimeSlotUser } from 'src/app/models/data/user.model';
import * as UserActions from '../actions/user.actions';
export const userFeatureKey = 'user';

export interface State {
  user: User;
  omisUser: OmisUser;
  timeslotBookingUser: TimeSlotUser;
  userSnapshot?: User;
  credentials: UserCredential;
  maskedMobile: string;
  uiloginFail: boolean;
  loginLoading: boolean;
  customerVisit: customerVisit;
  userLocation: UserLocation;
  preferences: Preference;
  userAuth: UserAuth[]
}

export const initialState: State = {
  user: null,
  omisUser: null,
  timeslotBookingUser: null,
  credentials: null,

  maskedMobile: "",
  uiloginFail: false,
  loginLoading: false,
  customerVisit: null,
  userLocation: null,
  preferences: null,
  userAuth: null
}


export const reducer = createReducer(
  initialState,
  on(UserActions.clearUserInfo, state => initialState),
  on(UserActions.loadUsers, state => state),
  on(UserActions.loadUsersSuccess, (state, action) => state),
  on(UserActions.loadUsersFailure, (state, action) => state),

  on(UserActions.signOut, (state) => {
    return {
      ...state,
      user: null,
      timeslotBookingUser: null,
      credentials: {
        salesiqUserId: "", jwtToken: ""
      }
    }
  }),

  on(UserActions.setMaskedMobile, (state, action) => {
    return {
      ...state,
      maskedMobile: action.mobile
    }
  }),

  on(UserActions.setCredentials, (state, action) => {
    return {
      ...state,
      credentials: action.token
    }
  }),

  on(UserActions.setUserInfo, (state, action) => {
    return {
      ...state,
      user: action.user
    }
  }),
  
  on(UserActions.setTimeslotBookingUser, (state, action) => {
    return {
      ...state,
      timeslotBookingUser: action.timeslotBookingUser
    }
  }),

  on(UserActions.snapshotUser, (state) => {
    return {
      ...state,
      userSnapshot: state.user
    }
  }),

  on(UserActions.clearUserSnapshot, (state) => {
    return {
      ...state,
      userSnapshot: null
    }
  }),

  on(UserActions.restoreUserSnapshot, (state) => {
    return {
      ...state,
      user: state.userSnapshot
    }
  }),

  on(UserActions.updatePartialUser, (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        ...action.update
      }
    }
  }),

  // on(UserActions.updatePreferences, (state, action) => {
  //   return {
  //     ...state,
  //     preferences: {
  //       ...state.preferences,
  //       ...action.update
  //     }
  //   }
  // }),

  on(UserActions.setuiloginFail, (state, action) => {
    return {
      ...state,
      uiloginFail: action.uiloginFail
    }
  }),

  on(UserActions.clearuiloginFail, (state, action) => {
    return {
      ...state,
      uiloginFail: initialState.uiloginFail
    }
  }),

  on(UserActions.setuiloginLoading, (state, action) => {
    return {
      ...state,
      loginLoading: action.loginLoading
    }
  }),

  on(UserActions.clearuiloginLoading, (state, action) => {
    return {
      ...state,
      loginLoading: initialState.loginLoading
    }
  }),

  on(UserActions.updateCurrentLocation, (state, action) => {
    return {
      ...state,
      userLocation: action.userLocation
    }
  }),

  on(UserActions.clearCurrentLocation, (state) => {
    return {
      ...state,
      userLocation: initialState.userLocation
    }
  },
  ),

  on(UserActions.updateCustomerVisit, (state, action) => {
    return {
      ...state,
      customerVisit: action.customerVisit
    }
  }),

  on(UserActions.updateModulePreferences, (state, action) => {
    return {
      ...state,
      preferences: action.preferences
    }
  }),

  on(UserActions.clearCustomerVisit, (state, action) => {
    return {
      ...state,
      customerVisit: initialState.customerVisit
    }
  }),

  on(UserActions.setUserAuth, (state, action) => {
    return {
      ...state,
      userAuth: action.userAuth
    }
  }),

  on(UserActions.clearUserAuth, (state) => {
    return {
      ...state,
      userAuth: initialState.userAuth
    }
  }),

  on(UserActions.upsertUserAuth, (state, action) => {
    const baseUserAuth = state.userAuth.filter(item => item.moduleId !== action.userAuth.moduleId)
    return {
      ...state,
      userAuth: [...baseUserAuth, {
        // ...origSO,
        ...action.userAuth
      }]
    }
  }),

);
